var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField = (obj, key2, value) => {
  __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
  return value;
};
import Service from "./Service.js";
import keyCodes from "../utils/keyCodes.js";
class Key extends Service {
  constructor() {
    super(...arguments);
    __publicField(this, "previousEvent");
    __publicField(this, "props", {
      event: null,
      triggered: 0,
      isUp: false,
      isDown: false,
      ENTER: false,
      SPACE: false,
      TAB: false,
      ESC: false,
      LEFT: false,
      UP: false,
      RIGHT: false,
      DOWN: false,
      direction: "none"
    });
  }
  init() {
    document.addEventListener("keydown", this);
    document.addEventListener("keyup", this);
  }
  handleEvent(event) {
    this.updateProps(event);
    this.trigger(this.props);
  }
  kill() {
    document.removeEventListener("keydown", this);
    document.removeEventListener("keyup", this);
  }
  updateProps(event) {
    var _a;
    this.props.event = event;
    Object.entries(keyCodes).forEach(([name, code]) => {
      this.props[name] = code === event.keyCode;
    });
    if (!this.previousEvent) {
      this.props.triggered = 0;
    }
    if (this.props.event.type === "keydown" && ((_a = this.previousEvent) == null ? void 0 : _a.type) === "keydown") {
      this.props.triggered += 1;
    } else {
      this.props.triggered = 1;
    }
    this.previousEvent = this.props.event;
    this.props.direction = this.props.event.type === "keydown" ? "down" : "up";
    this.props.isUp = this.props.event.type === "keyup";
    this.props.isDown = this.props.event.type === "keydown";
    return this.props;
  }
}
let instance;
let key;
function useKey() {
  if (!key) {
    if (!instance) {
      instance = new Key();
    }
    key = {
      add: instance.add.bind(instance),
      remove: instance.remove.bind(instance),
      has: instance.has.bind(instance),
      props: instance.updateProps.bind(instance)
    };
  }
  return key;
}
export {
  useKey as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
